// src/components/AddPaymentMethod.js

import  { useEffect,useState } from 'react';
import { useNavigate,useLocation } from 'react-router-dom';
import arrow_back_ios_new from "../../assets/Images/arrow_back_ios_new.png";
import { useAsaSession } from '../../services/AsaSessionServices';
import { useFintechLayouts } from '../../services/AsaApiServices';
import { useTranslation } from "react-i18next";
import "./SubscriptionManagement.css"; 
import {
  AnalyticsService,
  AnalyticsAction,
  AnalyticsFeature,
} from "../../services/AnalyticsService";

const SubscriptionAddPaymentMethod = () => {
  const { t } = useTranslation();
  const layout = useFintechLayouts();
  const { data: session } = useAsaSession();
  const navigate = useNavigate();
  const [dynamicLink, setDynamicLink] = useState<string | undefined>();
  const location = useLocation();
  const { state } = location;
  const returnurl = state?.returnurl;

  useEffect(() => {
    const pagedata = session?.sessionPages?.find((page) => page.pageNumber === 0)?.pageData;
    if (!pagedata) return;
    const parsedData = JSON.parse(pagedata);
    const linkAccountDynamicLink = parsedData.linkAccountDynamicLink;
    setDynamicLink(linkAccountDynamicLink);
  }, [session]);

  useEffect(() => {
    AnalyticsService.track(
      "Add Payment Method Viewed",
      AnalyticsAction.View,
      AnalyticsFeature.Payment,
    );
  }, []);

  const handleLinkAccountClick = () => {
    if (!session?.sessionPages) {
      console.error("UpdatedLocalData is not available.");
      return;
    }

    if (dynamicLink) {
      AnalyticsService.track(
        "Link Account Clicked",
        AnalyticsAction.Click,
        AnalyticsFeature.Payment,
      );
      window.location.href = dynamicLink;
    } else {
      console.error(t("backActionNotFound"));
    }
  };

  const handleBackClick = () => {
    if (!!!returnurl ) {
      navigate(-1); // Navigate back to the previous page in the browser history
    } else  {
      navigate(returnurl,{replace:true}); // This will navigate back to the previous page in the browser history
    }
  }

  const handleManualAddClick = () => {
    AnalyticsService.track(
      "Manual Add Payment Clicked",
      AnalyticsAction.Click,
      AnalyticsFeature.Payment,
    );
    navigate("/addcreditcard", {
      replace: true,
      state: { returnurl: returnurl },
    });
  };

  return (
    <div
      className="bg-gradient-to-b from-[#705AE2] to-[#490C95] h-screen flex flex-col items-center text-center pt-10 relative"
      style={layout?.backGroundStyle}
    >
      <div className="absolute top-4 left-4 rounded-lg p-1 w-[40px] h-[40px] flex items-center justify-center">
        <img
          className="cursor-pointer w-[18px] h-[18px] mt-8"
          src={arrow_back_ios_new}
          alt={t("back")}
          onClick={handleBackClick}
        />
      </div>
      <h1 className="text-white  font-bold text-xl">{t("addPaymentMethod")}</h1>
      <div className="bg-[#EBECF0] dark:bg-[#121212] dark:text-white text-[#4E4E4E]  rounded-t-3xl shadow-md mt-10 w-full max-w-md p-6 flex-grow flex flex-col">
        <PaymentButton
          onClick={handleLinkAccountClick}
          style={layout?.buttonStyle}
          title={t("linkAccount")}
          subtitle={t("updatedAutomatically")}
          disabled={!!!dynamicLink}
        />
        <PaymentDescription t={t} />
        <DividerWithText text={t("or")} />
        <ManualAddButton t={t} onClick={handleManualAddClick} />
      </div>
    </div>
  );
};

const PaymentButton = ({
  onClick,
  style,
  title,
  subtitle,
  disabled,
}: {
  onClick: () => void;
  style: any;
  title: string;
  subtitle: string;
  disabled: boolean;
}) => (
  <button
    className="bg-[#705AE2] text-white box-style-add-payments py-3 px-8 rounded-full shadow-md mb-4 mx-auto w-full max-w-[294px] h-[56px] flex flex-col justify-center items-center"
    onClick={onClick}
    style={style}
    disabled={disabled}
  >
    <span className="font-poppins font-medium text-[15px] leading-[20px] text-center">{title}</span>
    <span className="font-poppins text-[10px] leading-[20px] text-center">{subtitle}</span>
  </button>
);

const PaymentDescription = ({ t }: { t: (key: string) => string }) => (
  <p className=" mt-2 leading-4">
    <span className="font-poppins font-bold text-[13px]  cursor-pointer">{t("connectToAccounts")}</span>
    <br />
    <span className="font-poppins font-normal text-[13px]  cursor-pointer">{t("bankAccountsCreditCards")}</span>
    <br />
    <span className="font-normal font-poppins font-normal text-[13px]  cursor-pointer">{t("investmentAccounts")}</span>
  </p>
);

const DividerWithText = ({ text }: { text: string }) => (
  <div className="flex items-center my-10">
    <hr className="w-full border-[#4E4E4E]" />
    <span className="px-2 text-gray-500">{text}</span>
    <hr className="w-full border-[#4E4E4E]" />
  </div>
);

const ManualAddButton = ({ t, onClick }: { t: (key: string) => string; onClick: () => void }) => (
  <>
    <span className="font-poppins font-normal text-[13px] cursor-pointer font-poppins">{t("addPaymentMethodManually")}</span>
    <button
      onClick={onClick}
      className="my-6 font-poppins bg-white border-gray-300 text-gray-700 font-semibold rounded-full py-4 px-6 w-full shadow-md hover:bg-gray-100"
    >
      {t("manuallyAdd")}
    </button>
  </>
);

export default SubscriptionAddPaymentMethod;